module.exports = __webpack_public_path__ + "img/beer_id-5.bbd75f7b.png";